export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Vérification de l’adresse courriel',
        step1Title: 'Aidez-nous à protéger votre compte',
        step1MessageLine1: 'Pour améliorer la sécurité de votre compte, nous devons effectuer une vérification supplémentaire.',
        step1MessageLine2: 'Vous recevrez un mot de passe unique par courriel.',
        step1MessageLine3: 'Les renseignements recueillis ici ne seront utilisés qu’à des fins de vérification. En cliquant sur « Envoyer », vous (1) acceptez la version actuelle de nos',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        step1MessageLine3Part2: 'et confirmez (2) avoir lu notre',
        privacyPolicy: 'politique de confidentialité',
        send: 'Envoyer le courriel de vérification',
        infoTitle: 'Aidez-nous à protéger votre compte',
        infoMessage: 'Cela nous permet de nous assurer que vous seul avez accès à votre compte et de protéger vos renseignements contre tout accès non autorisé.',
        infoOk: 'Compris',
        step2Title: 'Vérifiez votre boîte de réception et entrez votre code de vérification',
        step2MessageLine1: `Vous recevrez un code à l’adresse <strong>${vars[0]}</strong> si elle est liée à un compte Beauty Insider.`,
        step2MessageLine2: 'Vous n’avez pas reçu de courriel?',
        resend: 'Envoyez le courriel à nouveau',
        step2MessageLine2Part2: 'code dans',
        seconds: 'secondes',
        errorOtpIncorrect: 'Le code que vous avez entré est incorrect. Veuillez vérifier et essayer de nouveau.',
        errorGenericMessage: 'Nous ne pouvons pas confirmer votre mot de passe à usage unique pour l’instant. Veuillez réessayer plus tard.',
        infoErrorTitle: 'Erreur',
        infoErrorMessage: 'Nous ne pouvons pas envoyer de mot de passe à usage unique à votre adresse courriel pour l’instant. Veuillez réessayer plus tard.',
        infoErrorTooManyAttemptsTitle: 'Tentatives épuisées',
        infoErrorTooManyAttemptsMessage: 'Tentatives épuisées. Veuillez réessayer plus tard.',
        accessibilityInfoIcon: 'icône d’information',
        expiredOTP: 'Le code saisi a expiré. Veuillez renvoyer un nouveau code.'

    };

    return resources[label];
}
